module.exports = "<app-single-unit-log\n  [unitId]=\"activatedRoute.snapshot.params.id\"\n></app-single-unit-log>\n"